import getIsAndroid from "selectors/device/getIsAndroid";
import { createSelector } from "reselect";

const getPixelRatio = (state) => state.viewport.pixelRatio;
const getDimensions = (state) => state.viewport.dimensions;

export default createSelector(
  getDimensions,
  getPixelRatio,
  getIsAndroid,
  (dimensions, pixelRatio, isAndroid) => {
    if (isAndroid) {
      const minimumThreshold = 1280 * 720; // 1080 screen
      const numPixels =
        pixelRatio * dimensions.height * (dimensions.width * pixelRatio);
      if (numPixels < minimumThreshold) {
        return true;
      }
    }
    return false;
  },
);
